/**
 * Removes the hash from the current URL using history.replaceState.
 * Use when unmounting UI that was opened via URI fragment (e.g. #pwa-guide) so that
 * refresh does not re-open it.
 *
 * @param fragment - If provided, only clear when current hash (without #) equals this value.
 *                   If omitted, clear any hash.
 */
export function clearUrlFragment(fragment?: string): void {
  if (typeof window === 'undefined') return;
  const currentHash = window.location.hash.replace(/^#/, '');
  if (fragment !== undefined && currentHash !== fragment) return;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
